import styles from "./styles.module.scss";

import Visa from "@assets/img/png/Visa.png";
import MasterCard from "@assets/img/png/MasterCard.png";
import Maestro from "@assets/img/png/Maestro.png";
import Discover from "@assets/img/png/Discover.png";
import Amex from "@assets/img/png/Amex.png";
import DinersClub from "@assets/img/png/DinersClub.png";

export const CardLogos = () => {
  return (
    <div className={styles.cardLogosWrapper}>
      <img src={Visa} alt="Visa" />
      <img src={MasterCard} alt="MasterCard" />
      <img src={Maestro} alt="Maestro" />
      <img src={Discover} alt="Discover" />
      <img src={DinersClub} alt="Diners Club" />
      <img src={Amex} alt="American Express" />
    </div>
  );
};
